import { axios } from "../lib/request";

/**
 * Verifies if a user with the given email already exists in the system.
 * 
 * @param {string} email - The email address to verify.
 * @returns {Promise<Object|null>} The verification response payload or null if the request fails.
 */
export const verifyUser = async email => {
    let returnVerification;
    try {
        const response = await axios({
            url: process.env.REACT_APP_API_VERIFY_USER_URL,
            params: {
                email,
            }
        })
        returnVerification = response.data
    } catch (e) {
        returnVerification = null
    }
    return returnVerification;
}

/**
 * Creates a new user account via the API.
 * 
 * @param {Object} params - The user registration payload (name, email, password, etc.).
 * @returns {Promise<Object>} The API response promise.
 */
export const createUser = params => {
    return axios.post("https://app.socialscavenger.com/v1/users.json", params)
}